import { Col, Image, Row } from "antd";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useLocation } from "react-router";
import styled from "styled-components";
import PageLayout from "../../components/atoms/PageLayout";
import { RepairShopReview } from "../../model/RepairShopReivew";
import { HttpError } from "../../network/types";
import { alertError, getKorOrderServiceType } from "../../shared/utils";
import { theme } from "../../theme";

import { fetchReviewDetail } from "../../apis/Review/apis";
import { ReviewRate } from "../../components/molecures/ReviewRate";

const ReviewDetail: React.FC = () => {
  const getReviewDetailMutation = useMutation(fetchReviewDetail, {
    onSuccess: (res) => {
      setValues(res);
    },
    onError: (err: HttpError) => {
      alertError(err.message);
    },
  });
  const { pathname } = useLocation();
  const splitPathname = pathname.split("/");
  const id = pathname.split("/")[splitPathname.length - 1];
  const [values, setValues] = useState<RepairShopReview>();

  useEffect(() => {
    getReviewDetailMutation.mutate(Number(id));
  }, []);

  const reviewScore = values?.reviewItem?.reviewScore || 0;
  return (
    <PageLayout title="리뷰 내용">
      <Row gutter={[0, 24]} align="middle">
        <StyledCol span={24}>
          <PageLabel>등록일</PageLabel>
          {dayjs(values?.createdAt).format("YYYY/MM/DD")}
        </StyledCol>

        <StyledCol span={24}>
          <PageLabel>작업정보</PageLabel>
          {values?.repair
            ? `${values?.repair.vehicleModel || "-"} / ${getKorOrderServiceType(
                values.orderType
              )}${values.repair.isWheelAlignment ? " / 휠 얼라인먼트" : ""}` ||
              "-"
            : "-"}
        </StyledCol>

        <StyledCol span={24}>
          <PageLabel>평점</PageLabel>
          <ReviewRate value={reviewScore} />
          <StyledScoreText>{reviewScore}</StyledScoreText>
          <StyledScoreLabel>
            {reviewScore < 3 ? "아쉬워요" : "만족해요"}
          </StyledScoreLabel>
        </StyledCol>
        <StyledCol span={24}>
          <PageLabel>서비스 평가</PageLabel>
          {values?.reviewItem.reviewItemLabels.join(" / ")}
        </StyledCol>
        <StyledCol span={24}>
          <PageLabel>리뷰내용</PageLabel>
          <StyledTextArea>
            {values?.reviewItem.review.reviewContent}
          </StyledTextArea>
        </StyledCol>
        <StyledCol span={24}>
          <PageLabel />
          <Image.PreviewGroup>
            <Row gutter={[8, 0]}>
              {values?.reviewItem.review.reviewMedias.map(({ media }) => (
                <Col key={media.id}>
                  <Image
                    wrapperStyle={{ borderRadius: 4, overflow: "hidden" }}
                    alt="review-image"
                    width={100}
                    height={100}
                    src={
                      media.smallFullUrl ||
                      media.bufferFullUrl ||
                      media.mediumFullUrl
                    }
                    preview={{
                      src:
                        media.bufferFullUrl ||
                        media.mediumFullUrl ||
                        media.largeFullUrl,
                    }}
                  />
                </Col>
              ))}
            </Row>
          </Image.PreviewGroup>
        </StyledCol>
      </Row>
    </PageLayout>
  );
};

export default ReviewDetail;
const PageLabel = styled.div`
  ${theme.typo.heading.b16};
  flex: 0 0 165px;
  vertical-align: top;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
`;
const StyledCol = styled(Col)`
  width: 100%;
  vertical-align: middle;
  display: flex;
  flex-wrap: nowrap;
`;
const StyledScoreText = styled.span`
  margin-left: 3px;
`;
const StyledScoreLabel = styled.span`
  margin-left: 12px;
`;
const StyledTextArea = styled.div`
  white-space: pre-wrap;
`;
